import { render, staticRenderFns } from "./feeDiscountManageList.vue?vue&type=template&id=c320c2d2&scoped=true"
import script from "./feeDiscountManageList.vue?vue&type=script&lang=js"
export * from "./feeDiscountManageList.vue?vue&type=script&lang=js"
import style0 from "./feeDiscountManageList.vue?vue&type=style&index=0&id=c320c2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c320c2d2",
  null
  
)

export default component.exports